export default __webpack_public_path__ + "static/media/jesus-resureccion-4.9e06fcdf.png";